import { createApp } from 'vue'
import { nextTick } from "@vue/runtime-core"

import App from './App.vue'
//import App2 from './App2.vue'
import i18n from './i18n'
import router from "./router";
import store from "./store"; //2022/3/29 simon 新增
import axios from "@/help/axios";//2022/3/29 simon 修改過
import api from "@/service/api"; // 第二步驟會用到
import VueAxios from "vue-axios";
//import signalr from './utils/signalR'
import signalr from './utils/signalR2'
import CKEditor from '@ckeditor/ckeditor5-vue';

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@vueup/vue-quill/dist/vue-quill.bubble.css';


import PrimeVue from 'primevue/config';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import MultiSelect from 'primevue/multiselect';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import ToastService from "primevue/toastservice";
import Menubar from 'primevue/menubar';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import PanelMenu from 'primevue/panelmenu';
import Textarea from 'primevue/textarea';
import Steps from 'primevue/steps';
import FileUpload from 'primevue/fileupload';
import RadioButton from 'primevue/radiobutton';
import Editor from 'primevue/editor';
import ProgressSpinner from 'primevue/progressspinner';
import CascadeSelect from 'primevue/cascadeselect';
import Carousel from 'primevue/carousel';
import Badge from 'primevue/badge';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Tooltip from 'primevue/tooltip';
import Card from 'primevue/card';
import Calendar from 'primevue/calendar';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import "primevue/resources/themes/lara-light-indigo/theme.css";
import "primevue/resources/primevue.min.css";
import 'primeicons/primeicons.css';
import "primeflex/primeflex.css";
// import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "@/assets/bootstrap/css/bootstrap.min.css"
import "@/assets/iconfont/font/bootstrap-icons.css"
// import "./css/layout.css"
import "@/assets/css/inner.css"
import "@/assets/css/site.css"

import "@/assets/css/progress-wizard.min.css"

// import "./bootstrap/js/bootstrap.min.js"



/* import Loading from 'vue-loading-overlay'//2022/3/29 simon 新增
import 'vue-loading-overlay/dist/vue-loading.css'//2022/3/29 simon 新增 */

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';


import VueCookies from 'vue-cookies'

import VueCameraLib from 'vue-camera-lib'

/* import Vue3FormWizard from 'vue3-form-wizard'
import 'vue3-form-wizard/dist/style.css' */

import MyDateSingle from "./components/common/MyDateSingle.vue";
import MyStep from './components/common/MyStep.vue'
import MyMaterialGroup from './components/common/MyMaterialGroup.vue'
import MyEmailAddress from './components/common/MyEmailAddress.vue'
import MyUserName from './components/common/MyUserName.vue'
import MyShortName from './components/common/MyShortName.vue'

import MySourcerContact from './components/common/MySourcerContact.vue'
import MyApprovalStaff from './components/common/MyApprovalStaff.vue'
import MyBusinessType from './components/common/MyBusinessType.vue'
import MyUploadFile from './components/common/MyUploadFile.vue'
import MyUploadImage from './components/common/MyUploadImage.vue'
import MyMFGCode from './components/common/MyMFGCode.vue'

import JsonExcel from "vue-json-excel3";

import MyMFGSearchTerm from './components/common/MyMFGSearchTerm.vue'
import MyVendorCode from './components/common/MyVendorCode.vue'
import MyVendorCode4User from './components/common/MyVendorCode4User.vue'
import MySystemSelect from './components/common/MySystemSelect.vue'
import MyCompanyCategory from './components/common/MyCompanyCategory.vue'
import MyCompanyAddress_CH from './components/common/MyCompanyAddress_CH.vue'
import MyCompanyAddress_EN from './components/common/MyCompanyAddress_EN.vue'
import MyCompanyName_CH from './components/common/MyCompanyName_CH.vue'
import MyCompanyName_EN from './components/common/MyCompanyName_EN.vue'
import MyApply from './components/common/MyApply.vue'
import MyApply4Vendor from './components/common/MyApply4Vendor.vue'

import MySelectVendorCode from './components/common/MySelectVendorCode.vue'
import MySelectMFGSearchTerm from './components/common/MySelectMFGSearchTerm.vue'
import MyCompalAD from './components/common/MyCompalAD.vue'
import MyDownloadFile from './components/common/MyDownloadFile.vue'
import MyInputText from './components/common/MyInputText.vue'
import MyStepWizard from './components/common/MyStepWizard.vue'
import MyStepWizard2 from './components/common/MyStepWizard2.vue'
import BulletinTop5 from './components/BulletinTop5.vue'
import Modal_Declaration from './components/Modal_Declaration.vue'


const app = createApp(App);
//const app2 = createApp(App2);
            // eslint-disable-next-line vue/multi-word-component-names
            
            //2022/3/29 simon 修改過
            app.use(store).use(router).use(VueAxios, axios);
           // app2.use(store).use(router).use(VueAxios, axios);
            app.use(i18n)
        
            
            // Make BootstrapVue available throughout your project
            app.use( CKEditor );
            
            app.use(PrimeVue).use(ToastService);
            //app2.use(PrimeVue).use(ToastService);
            app.use(VueCookies);
            //app2.use(VueCookies);
            app.use(ConfirmationService);
            //app2.use(ConfirmationService);


            app.use(VueCameraLib)
            //app2.use(VueCameraLib)
            //app.use(Vue3FormWizard)
            app.component('QuillEditor', QuillEditor)
            app.component('Loading', Loading);//2022/3/29 simon 新增
           // app2.component('Loading', Loading);//2022/3/29 simon 新增
            //app.use(PrimeVue).use(store).use(VueAxios, axios).use(ToastService).use(router).use(VueCookies);
            app.component("InputText", InputText);
            app.component("Button", Button);
           // app2.component("Button", Button);
            app.component("Dialog", Dialog);
           // app2.component("Dialog", Dialog);
            app.component("Checkbox", Checkbox);
            app.component("MultiSelect", MultiSelect);
            app.component("DataTable", DataTable);
            app.component("Column", Column);
            app.component("ColumnGroup", ColumnGroup);
            app.component("Row", Row);
            app.component("Toast", Toast);
           // app2.component("Toast", Toast);
            app.component("Menubar", Menubar);
            app.component("Textarea", Textarea);
            app.component("Steps", Steps);
            app.component("FileUpload", FileUpload);
            app.component("RadioButton", RadioButton);
            app.component("Dropdown", Dropdown);
            app.component("Accordion", Accordion);
            app.component("AccordionTab", AccordionTab);
            app.component("Editor", Editor);
            app.component("PanelMenu", PanelMenu);
            app.component("ProgressSpinner", ProgressSpinner);
            app.component("CascadeSelect", CascadeSelect);
            app.component("Carousel", Carousel);
            app.component("Badge", Badge);
            app.component("InputNumber", InputNumber);
            app.component("InputGroup", InputGroup);
            app.component("InputGroupAddon", InputGroupAddon);
            app.component("Card", Card);
          //  app2.component("Card", Card);
            app.component("ConfirmDialog", ConfirmDialog);
          //  app2.component("ConfirmDialog", ConfirmDialog);
            app.component("Calendar", Calendar);
            app.directive('tooltip', Tooltip);
            
            app.component('my-date-single', MyDateSingle);
            app.component("my-MaterialGroup", MyMaterialGroup);
            app.component("my-CompanyCategory", MyCompanyCategory);
            app.component("my-EmailAddress", MyEmailAddress);
            app.component("my-UserName", MyUserName);
            app.component("my-ShortrName", MyShortName);
            
            app.component("my-SourcerContact", MySourcerContact);
            app.component("my-ApprovalStaff", MyApprovalStaff);
            app.component("my-BusinessType", MyBusinessType);
            app.component("my-UploadFile", MyUploadFile);
            app.component("my-UploadImage", MyUploadImage);
            app.component("my-MFG-Code", MyMFGCode);
            app.component("my-MFG-SearchTerm", MyMFGSearchTerm);
            app.component("my-VendorCode", MyVendorCode);
            app.component("my-VendorCode4User", MyVendorCode4User);
            app.component("my-SystemSelect", MySystemSelect);
            app.component("my-CompanyAddress_CH", MyCompanyAddress_CH);
            app.component("my-CompanyAddress_EN", MyCompanyAddress_EN);
            app.component("my-CompanyName_CH", MyCompanyName_CH);
            app.component("my-CompanyName_EN", MyCompanyName_EN);
            app.component("my-Step", MyStep);
            app.component("my-Apply", MyApply);
            app.component("my-Apply-Vendor", MyApply4Vendor);
            app.component("my-select-VendorCode", MySelectVendorCode);
            app.component("my-select-MFGSearchTerm", MySelectMFGSearchTerm);
            app.component("my-CompalAD", MyCompalAD);
            app.component("my-DownloadFile", MyDownloadFile);
            app.component("my-InputText", MyInputText);
            app.component("my-StepWizard", MyStepWizard);
            app.component("my-StepWizard2", MyStepWizard2);
            app.component("BulletinTop5", BulletinTop5);
            app.component("download-excel", JsonExcel);

            app.component("Modal_Declaration", Modal_Declaration);
            

            nextTick(() => {
              // 代替 Vue.prototype.$xxx 绑定
              app.config.globalProperties.$signalr = signalr.signal;
              
            })

             
           // app2.config.globalProperties.$signalr = signalr.signal;
           
            app.config.globalProperties.$api = api; // 定義api這個常數給AXIOS存取json-server或實際api環境用

            app.config.globalProperties.format_date_yyyyMMdd = (date) => {
              const d=new Date(date);
              const Year = d.getFullYear();
              const Month =d.getMonth() + 1 > 9 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1);
              const Day = d.getDate() > 9 ? d.getDate() : "0" + d.getDate();
              let Format_string = "";
              Format_string = Year + "/" + Month + "/" + Day;
              return Format_string;
            };
            app.config.globalProperties.format_date_yyyyMMddHHmm = (date) => {
              const d=new Date(date);
              const Year = d.getFullYear();
              const Month = d.getMonth() + 1 > 9 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1);
              const Day = d.getDate() > 9 ? d.getDate() : "0" + d.getDate();
              const Hour = d.getHours() > 9 ? d.getHours() : "0" + d.getHours();
              const Minute = d.getMinutes() > 9 ? d.getMinutes() : "0" + d.getMinutes();
              
              let Format_string = "";
              Format_string = Year + "/" + Month + "/" + Day + " " + Hour + ":" + Minute;
              return Format_string;
            };


 function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  } 

  function GetParam() {
    var url = location.search; //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}

//设置cookie
function setCookie(cname, cvalue, exseconds, path) {
    var d = new Date();
    d.setTime(d.getTime() + (exseconds * 1000));
    var expires = "expires=" + d.toGMTString();
    path = path == "" ? "" : ";path=" + path;
    document.cookie = cname + "=" + cvalue + "; " + expires + path;
}
  
   import Service from "@/service/service";
  let appservice = new Service();
 
const urlParams = GetParam();
console.log('get t')
const p = urlParams['p'];
const t = urlParams['t'];
 if(p){
   store.state.startrouter= p;
   setCookie('startrouter', p, 24 * 60 * 60, "/")
 }
 
 if(getCookie("startrouter")){
  store.state.startrouter= getCookie("startrouter");
 }

 if(t){
  console.log('setCookie')
  setCookie('vip_token', t, 24 * 60 * 60, "/")
 }


if(getCookie("vip_token"))
{
    
    store.state.token=getCookie("vip_token");
    store.state.refreshToken=getCookie("vip_refreshToken");
    store.state.sessionCode=getCookie("vip_sessionCode"); 

   

    appservice.GetUserInfo().then((data) => {
        
        if(data && data.data){
            store.state.user = data.data;
            sessionStorage.setItem("user",  JSON.stringify(data.data) );
            sessionStorage.setItem("vip_token",  getCookie("vip_token") );
            sessionStorage.setItem("vip_refreshToken",  getCookie("vip_refreshToken") );
            sessionStorage.setItem("vip_sessionCode",  getCookie("vip_sessionCode") );
         /*   if(store.state.startrouter){
              app2.mount('#app')
           }
           else{ */
              app.mount('#app')
          // }
           
        }
    })
    .catch((error) => {
        console.log(error)
      
    });
}
else
{
  let host = window.location.host;
  let protocol = window.location.protocol;
  let url=process.env.VUE_APP_LOCAL_URL;
  if(url.indexOf(host)==-1){
    url =`${protocol}//${host}${process.env.VUE_APP_LOCAL_URL}` 
  }

    window.location.href = process.env.VUE_APP_SSO_URL+'/SSO/Login?clientId=SSO&redirectUrl='+url+'/LoginRedirect.html'
} 




